import styled from '@emotion/styled';
import { FONT } from '@zola/zola-ui/src/styles/emotion';
import * as COLOR_SYSTEM from '../../../util/colorSystem';

const BUBBLE_SIZES = {
  SM: 20,
  MD: 24,
  LG: 28,
};
const BUBBLE_OFFSET_TOP = {
  SM: -10,
  MD: -15,
  LG: -20,
};
const BUBBLE_OFFSET_RIGHT = {
  SM: -10,
  MD: -20,
  LG: -25,
};
export const CountBubble = styled.div<{ size: 'SM' | 'MD' | 'LG'; isDarkMode: boolean }>`
  border-radius: 50%;
  font-family: 'Proxima Nova';
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: 600;

  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ size, isDarkMode }) => `
    background-color: ${
      isDarkMode ? COLOR_SYSTEM.DARK_ICON_COUNT_BG : COLOR_SYSTEM.LIGHT_CART_COUNT_BG
    };
    color: ${isDarkMode ? COLOR_SYSTEM.DARK_ICON_COUNT_TEXT : COLOR_SYSTEM.LIGHT_CART_COUNT_TEXT};

    height: ${BUBBLE_SIZES[size]}px;
    width: ${BUBBLE_SIZES[size]}px;
    right: ${BUBBLE_OFFSET_RIGHT[size]}%;
    top: ${BUBBLE_OFFSET_TOP[size]}%;
  `}
`;

export const IconContainer = styled.div<{ isDarkMode: boolean }>`
  border-radius: 50%;
  width: 48px;
  height: 48px;
  ${({ isDarkMode }) => `
  background-color: ${isDarkMode ? COLOR_SYSTEM.DARK_ICON_BG : COLOR_SYSTEM.LIGHT_ICON_BG};
  svg {
    fill: ${isDarkMode ? COLOR_SYSTEM.DARK_ICON_TEXT : COLOR_SYSTEM.LIGHT_ICON_TEXT};
  }
  `}
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`;

export const Container = styled.div`
  position: relative;
`;
